import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	OnInit,
	Renderer2,
	ViewChild,
} from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatTabGroup } from "@angular/material/tabs";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { CONSTANT } from "src/app/constant";
import { OBComments } from "src/app/models/models";
import { CbtaModalComponent } from "src/app/shared/components/cbta-modal/cbta-modal.component";
import { LoaderService } from "src/app/shared/services/loader.service";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
	selector: "app-candidate-rating-form",
	templateUrl: "./candidate-rating-form.component.html",
	styleUrls: ["./candidate-rating-form.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CandidateRatingFormComponent implements OnInit, AfterViewInit {
	@ViewChild("baseContainer") baseContainer?: ElementRef;
	rfForm!: UntypedFormGroup;
	parentForm!: UntypedFormArray;
	parentFormArrayIndex: number = 0;
	panelOpenState: boolean = false;
	ratingAVal: number = 0;
	ratingBVal: number = 0;
	ratingCVal: number = 0;
	ratingFinalVal: number = 0;
	tabIndex: number = 0;
	CANDIDATE_ROLE = CONSTANT.CANDIDATE_ROLE;
	@Input("rfForm") set _(value: any) {
		this.rfForm = value as UntypedFormGroup;
	}
	@ViewChild("maneuverTabs") maneuverTabs!: MatTabGroup;
	@ViewChild("customTabContainer") customTabContainer!: ElementRef;
	obComments: Array<OBComments> = [];
	@ViewChild(MatTabGroup) tabGroup!: MatTabGroup;

	@Input() loaded: boolean = false;
	loadexpandManeuver: boolean = false;

	constructor(
		public sharedService: SharedService,
		private cd: ChangeDetectorRef,
		private loadingService: LoaderService,
		private dbService: NgxIndexedDBService,
		private renderer: Renderer2,
		private elRef: ElementRef,
		private dialog: MatDialog,
	) {
		const isManeuverExpanded = localStorage.getItem(CONSTANT.STORAGE_KEY.EXPANDED_MANEUVER);

		this.loadexpandManeuver = isManeuverExpanded && JSON.parse(isManeuverExpanded);
	}

	ngOnInit(): void {
		this.parentForm = this.rfForm.parent as UntypedFormArray;
		this.parentFormArrayIndex = this.parentForm.controls.findIndex((subform) => subform == this.rfForm);
	}

	ngAfterViewInit(): void {
		const tabLabels = this.elRef.nativeElement.querySelectorAll(".mat-mdc-tab-list");

		for (const t of tabLabels) {
			t.remove();
		}
	}

	get baseContainerWidth() {
		return this.baseContainer?.nativeElement.offsetWidth ?? 0;
	}

	get selectedIndex(): number {
		return this.tabGroup.selectedIndex ?? 0;
	}

	get traineeAssessmentId() {
		return this.rfForm?.get("traineeAssessmentId")!;
	}

	get candidateName() {
		return this.rfForm.get("candidateName")!;
	}

	get observations() {
		return this.rfForm.controls["observations"] as UntypedFormArray;
	}

	otherComments(index: number) {
		return this.observations.at(index).get("otherComents")!;
	}

	get maneuvers() {
		return this.observations.value.map((v: any) => {
			return v.maneuver;
		});
	}

	get TEMValue() {
		return this.observations.value.map((v: any) => {
			return v.safetyOutcome;
		});
	}

	listallOBComments(val: OBComments) {
		if (!this.obComments.includes(val)) {
			this.obComments.push(val);
		}
	}

	setTabIndex(index: number) {
		this.maneuverTabs.selectedIndex = index;
		this.tabIndex = index;
	}

	viewSummaryModal() {
		console.log(this.obComments);
		const dialogRef = this.dialog.open(CbtaModalComponent, {
			panelClass: "view-summary-modal",
			height: "560px",
			width: "1154px",
			hasBackdrop: true,
			data: {
				modalTitle: "Summary",
				modalName: "viewSummaryModal",
				modalContent: this.obComments,
				modalTraineeAssessmentId: this.traineeAssessmentId.value,
				noCloseBtn: true,
				modalBtnConfirmText: "Close",
			},
		});

		const sub = dialogRef.afterClosed().subscribe((a) => {
			sub.unsubscribe();
		});
	}

	selectedTabValue(event: any) {
		this.tabIndex = event.index;

		this.cd.detectChanges();
	}

	onManeuverExpand() {
		const container = this.customTabContainer.nativeElement;
		container.scrollLeft = 0;

		this.loadexpandManeuver = !this.loadexpandManeuver;
		localStorage.setItem(CONSTANT.STORAGE_KEY.EXPANDED_MANEUVER, JSON.stringify(this.loadexpandManeuver));
	}
}
